<template>
  <v-app>
    <council-list
          view_type="moderator"
        />

  </v-app>
</template>
<script>

import councilList from '../components/Council/councilList.vue';

export default {
  name: 'ModeratorCouncilPage',
  components: {
    councilList,
  },
  data() {
    return {};
  },

};
</script>
